/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { Condition } from './condition';

/**
 * ObjectStatus of the object.
 * @export
 * @interface ObjectStatus
 */
export interface ObjectStatus {
    /**
     * The conditions of the objet with details.
     * @type {Array<Condition>}
     * @memberof ObjectStatus
     */
    'conditions': Array<Condition>;
    /**
     * The last probe report time.
     * @type {string}
     * @memberof ObjectStatus
     */
    'lastProbeTime'?: string;
    /**
     * Phase of an object.
     * @type {string}
     * @memberof ObjectStatus
     */
    'phase'?: ObjectStatusPhaseEnum;
}

export const ObjectStatusPhaseEnum = {
    PHASE_UNSPECIFIED: 'PHASE_UNSPECIFIED',
    CREATING: 'CREATING',
    READY: 'READY',
    FAILED: 'FAILED',
    UNKNOWN: 'UNKNOWN',
    DELETING: 'DELETING',
    DELETED: 'DELETED'
} as const;

export type ObjectStatusPhaseEnum = typeof ObjectStatusPhaseEnum[keyof typeof ObjectStatusPhaseEnum];


